const themeSuffixMap: Record<string, string> = {
  dark: 'dark',
  highcontrast: 'contrast',
  contrast: 'contrast',
};

export function resolveThemeSuffix(themeName: string | null | undefined): string {
  if (!themeName) return 'light';
  return themeSuffixMap[themeName.toLowerCase()] ?? 'light';
}

function getParamCaseInsensitive(params: URLSearchParams, name: string): string | null {
  const lower = name.toLowerCase();
  let result: string | null = null;
  params.forEach((value, key) => {
    if (result === null && key.toLowerCase() === lower) result = value;
  });
  return result;
}

export function applyIdsThemeCss(): void {
  const params = new URLSearchParams(location.search);
  const themeName = getParamCaseInsensitive(params, 'inforThemeName');
  const suffix = resolveThemeSuffix(themeName);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `themes/ids-theme-default-${suffix}.css`;
  document.head.appendChild(link);
}
